import React from 'react';

import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';
import { useAppSelector } from 'store/hook';

import OverviewCommunitiesTable from './OverviewCommunitiesTable';

const OverviewCompetitors = () => {
  const { competitors } = useAppSelector((state) => state.global);

  return <OverviewCommunitiesTable type={COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR} communities={competitors} />;
};

export default OverviewCompetitors;
